import { c as _c } from "react/compiler-runtime";
import { FormInput, Popover, PrimaryButton } from '@systemeio/ui';
import { addField } from 'modules/contacts/contact-page/api/contact-edit-api';
import { ContactFieldCreateInterface } from 'modules/contacts/contact-page/types/contact-edit-interface';
import { ContactFieldApiInterface } from 'modules/contacts/types/contact-filter-interface';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
import { AddIcon, QuestionMarkIcon } from '@systemeio/ui/icons';
interface ContactAddFieldProps {
  mutateFields: KeyedMutator<ContactFieldApiInterface>;
  disabled: boolean;
}
const defaultValues: ContactFieldCreateInterface = {
  fieldName: '',
  slug: ''
};
const defaultErrors: Record<keyof ContactFieldCreateInterface, string> = {
  fieldName: '',
  slug: ''
};
const ContactAddField = t0 => {
  const $ = _c(32);
  const {
    mutateFields,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== mutateFields) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        const response = await addField(data);
        await mutateFields(data_0 => {
          if (data_0) {
            return {
              ...data_0,
              items: [...data_0.items, response.data]
            };
          }
        }, false);
      }, setErrors);
    };
    $[0] = mutateFields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCreate = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AddIcon className="main-transition-colors" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.contact_page.add_new_field");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span>{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabled || $[9] !== t5) {
    t6 = <PrimaryButton disabled={disabled} onClick={t2} className="w-fit">{t3}{t5}</PrimaryButton>;
    $[8] = disabled;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.contact_page.custom_field");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== errors || $[15] !== t) {
    t9 = {
      field: "fieldName",
      onRender: (value, onChange, state, onChangeState) => <FormInput key="fieldName-create" label={t("global.name")} value={value} onChange={e => {
        onChangeState({
          ...state,
          fieldName: e.target.value,
          slug: e.target.value.replaceAll(" ", "_").replace(/[^a-zA-Z|\-_\d+]/g, "").toLowerCase()
        });
      }} error={errors.fieldName} />
    };
    $[14] = errors;
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== errors || $[18] !== t) {
    t10 = {
      field: "slug",
      onRender: (value_0, onChange_0) => <FormInput key="slug-create" label={<div className="flex items-center gap-1.5">{t("dashboard.contact_page.unique_key")}<Popover label={t("dashboard.contact_page.unique_key_description")} popoverClassName="w-[300px] sm:w-[350px]">{_temp}</Popover></div>} value={value_0} onChange={e_0 => onChange_0(e_0.target.value)} error={errors.slug} />
    };
    $[17] = errors;
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = [t9, t10];
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["fieldName", "slug"];
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== onCreate || $[25] !== opened || $[26] !== t11 || $[27] !== t7) {
    t13 = <CreateModal caption={t7} opened={opened} onClose={t8} defaultValues={defaultValues} creatable={t11} onCreate={onCreate} requiredFields={t12} />;
    $[24] = onCreate;
    $[25] = opened;
    $[26] = t11;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t6) {
    t14 = <div className="flex h-[42px] justify-center lg:pl-5">{t6}{t13}</div>;
    $[29] = t13;
    $[30] = t6;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export default ContactAddField;
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}